export default __webpack_public_path__ + "static/features-bg-69c5091d6233e25e8ef6cb029da8bb65.png";